import React from "react";
import { motion } from "framer-motion";
import { CiCirclePlus } from "react-icons/ci";
import CustomAction from "../../../../controls/CustomAction";
import Flag from "react-world-flags";
import { IoIosCheckmarkCircle } from "react-icons/io";

export default function TripOverview({
  mainColor,
  setOpenCountryModal,
  tripCountries,
  setTripCountries,
  setSelectedCountriesModal,
  preConsultationSteps,
  setPreConsultationSteps,
  handleNextStepPC,
}) {
  const handleRemoveCountry = (countryCode) => {
    const updatedCountries = tripCountries.filter(
      (country) => country.code !== countryCode
    );

    setTripCountries(updatedCountries);
    setSelectedCountriesModal(updatedCountries);

    const filteredSteps = preConsultationSteps.filter(
      (step) => step.countryCode !== countryCode
    );

    setPreConsultationSteps(filteredSteps.length > 0 ? [filteredSteps[0]] : []);
  };

  const handleThisIsCorrect = () => {
    if (tripCountries.length === 0) return;

    const typeOrder = {
      "vaccine-selection": 1,
      "trip-purpose": 2,
      "environment-type": 3,
      "accommodation-type": 4,
      "vaccine-history": 5,
      "required-medical-questions": 999,
    };

    const newSteps = [
      ...preConsultationSteps,

      ...(preConsultationSteps.find((step) => step.type === "vaccine-selection")
        ? []
        : [
            {
              title: "Tell us about your trip",
              type: "vaccine-selection",
            },
          ]),

      ...tripCountries
        .filter(
          (country) =>
            !preConsultationSteps.find(
              (step) =>
                step.type === "trip-purpose" &&
                step.countryCode === country.code
            )
        )
        .map((country) => ({
          title: `About your trip`,
          type: "trip-purpose",
          countryName: country.name,
          countryCode: country.code,
        })),

      ...tripCountries
        .filter(
          (country) =>
            !preConsultationSteps.find(
              (step) =>
                step.type === "environment-type" &&
                step.countryCode === country.code
            )
        )
        .map((country) => ({
          title: `About your trip`,
          type: "environment-type",
          countryName: country.name,
          countryCode: country.code,
        })),

      ...tripCountries
        .filter(
          (country) =>
            !preConsultationSteps.find(
              (step) =>
                step.type === "accommodation-type" &&
                step.countryCode === country.code
            )
        )
        .map((country) => ({
          title: `About your trip`,
          type: "accommodation-type",
          countryName: country.name,
          countryCode: country.code,
        })),

      ...(preConsultationSteps.find((step) => step.type === "vaccine-history")
        ? []
        : [
            {
              title: "About your trip",
              type: "vaccine-history",
            },
          ]),

      ...(preConsultationSteps.find(
        (step) => step.type === "required-medical-questions"
      )
        ? []
        : [
            {
              title: "Required Medical Questions",
              type: "required-medical-questions",
            },
          ]),
    ];

    const sortedSteps = newSteps.sort((a, b) => {
      if (a.type === "required-medical-questions") return 1;
      if (b.type === "required-medical-questions") return -1;
      return typeOrder[a.type] - typeOrder[b.type];
    });


    setPreConsultationSteps(sortedSteps);
    handleNextStepPC();
  };

  return (
    <motion.div
      initial={{ y: 50, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ type: "spring", stiffness: 100, delay: 0.5 }}
      exit={{ y: 50, opacity: 0 }}
      className="bf-content-wrapper pc-trip-overview"
    >
      <div className="bf-content-header">
        <h2 className="bf-title" style={{ color: mainColor }}>
          Overview of your trip
        </h2>
        <p className="bf-subtitle">
          Choose your travel destination(s) so we can ensure you're covered with
          the right vaccines and health advice
        </p>
      </div>

      <div className="bf-content-body">
        <div
          className={`pc-countries-wrapper ${
            tripCountries.length > 0 ? "populated" : "not-populated"
          }`}
        >
          {tripCountries.length > 0 ? (
            <>
              {tripCountries.map((country, index) => (
                <div className="country-box" key={country.code}>
                  <p className="name">{country.name}</p>
                  <div className="flag-tick">
                    {index === 0 ? (
                      <div className="position">
                        <p>1ST</p>
                      </div>
                    ) : index === 1 ? (
                      <div className="position">
                        <p>2ND</p>
                      </div>
                    ) : index === 2 ? (
                      <div className="position">
                        <p>3RD</p>
                      </div>
                    ) : (
                      <></>
                    )}
                    <div className="flag-container">
                      <Flag code={country.code} />
                    </div>

                    <IoIosCheckmarkCircle
                      className="checkmark"
                      color={mainColor}
                      size={22}
                      onClick={() => handleRemoveCountry(country.code)}
                    />
                  </div>
                </div>
              ))}
              <button
                className="add-country-btn"
                onClick={() => setOpenCountryModal(true)}
              >
                <p>Add more countries</p>
                <CiCirclePlus size={18} />
              </button>
            </>
          ) : (
            <>
              <p className="error">No countries have been selected!</p>
              <button
                className="add-country-btn"
                onClick={() => setOpenCountryModal(true)}
              >
                <p>Add Countries</p>
                <CiCirclePlus size={18} />
              </button>
            </>
          )}
        </div>
      </div>
      <CustomAction
        mainColor={mainColor}
        text={"This is Correct"}
        action={() => {
          handleThisIsCorrect();
        }}
        disabled={tripCountries.length === 0}
      />
    </motion.div>
  );
}
